import { Box, Typography } from '@mui/material'
import { COLORS } from '../constants/colors'
import { TEXT } from '../constants/text'

export default function PrivacyPage() {
  return (
    <Box sx={{ maxWidth: 700, mx: 'auto', py: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 900, mb: 3, color: COLORS.gold.primary }}>
        Privacy Policy
      </Typography>

      <Typography sx={{ fontSize: '0.85rem', color: COLORS.text.secondary, lineHeight: 1.8, mb: 3 }}>
        Your privacy matters. This policy outlines how {TEXT.BUSINESS.NAME} handles your data.
      </Typography>

      <Section title="1. Data We Collect">
        <strong>Wallet address</strong> — Used solely for authentication and tier verification.{'\n'}
        <strong>Usage analytics</strong> — Anonymous page views and feature usage to improve our service.{'\n'}
        We do NOT collect private keys, seed phrases, or personal identification information.
      </Section>

      <Section title="2. How We Use Data">
        Your wallet address is used to verify your subscription tier and enforce rate limits.
        Analytics data is aggregated and used to improve service reliability and feature development.
      </Section>

      <Section title="3. Data Sharing">
        We do not sell, rent, or share your data with third parties. Wallet addresses may be
        checked against OFAC sanctions lists for compliance purposes.
      </Section>

      <Section title="4. Data Retention">
        Session data is stored temporarily and cleared upon disconnection. Subscription records
        are retained for the duration of your subscription plus 30 days.
      </Section>

      <Section title="5. Security">
        All communications are encrypted via TLS. Our infrastructure follows security best
        practices. As a non-custodial service, we have no access to your funds or keys.
      </Section>

      <Section title="6. Changes">
        We may update this policy periodically. Changes will be reflected on this page with
        an updated effective date.
      </Section>
    </Box>
  )
}

function Section({ title, children }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={{ fontWeight: 700, fontSize: '0.95rem', mb: 0.5 }}>
        {title}
      </Typography>
      <Typography sx={{ fontSize: '0.85rem', color: COLORS.text.secondary, lineHeight: 1.8, whiteSpace: 'pre-line' }}>
        {children}
      </Typography>
    </Box>
  )
}
